import React, { Component } from 'react';

class PropertyRooms extends Component {

  getRoomLayout() {
    const rooms = [];
    const prs = this.props.propertyRooms.collection;
    const bprs = this.props.bookingRooms.collection;

    for (const i in prs) {
      let found = false;
      for (const j in bprs) {
        if (bprs[j].room.id === prs[i].id) {
          found = true;
          rooms.push({
            name: bprs[j].room.name,
            description: bprs[j].roomtype.description,
            default: false
          });
        }
      }

      if (!found) {
        // find default roomtype
        const def = prs[i].roomtypes.filter((rt) => {
          return rt.default === true;
        });
        if (def && def.length > 0) {
          rooms.push({
            name: prs[i].name,
            description: def[0].roomtype.description,
            default: true
          });
        }
      }
    }
    return rooms.map((rt, i) => {
      return (
        <div key={ i }>
          { rt.name } - { rt.description }
        </div>
      );
    })
  }

  render() {
    if (!this.props.propertyRooms || this.props.propertyRooms.getTotal() === 0) {
      return null;
    }

    return (
      <tr><td>Rooms</td><td>{ this.getRoomLayout() }</td></tr>
    );
  }
}

export default PropertyRooms;


// WEBPACK FOOTER //
// ./src/PropertyRooms.js